import { render, staticRenderFns } from "./crudMethodsPayment.vue?vue&type=template&id=aafef06c&"
import script from "./crudMethodsPayment.vue?vue&type=script&lang=js&"
export * from "./crudMethodsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports